import React, { Component } from 'react';
import { connect } from 'react-redux';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import COMPANIES_CONTROLLER from '../../controllers/companies';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import SingleCountrySelector from '../selectors/country/SingleCountrySelector.jsx';
import SingleUserSelector from '../selectors/user/SingleUserSelector';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import ConfirmationModal from '../modals/ConfirmationModal';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import ENUMS, { CompanyVatGroupTypeEnum, FeatureFlagEnum } from '../../utils/enums';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import getClientConfig from '../../utils/getClientConfig.js';
import _ from 'underscore';
import { SSelect } from "@avalara/skylab-sdk/react";

const FORM_NAME = 'COMPANY_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const OSSImportRegEx = "^((IM)[0-9]{10})$";
const OSSNonUnionRegEx = "^((EU)[0-9]{9})$";
const OSSImportIntermedRegEx = "^((IN)[0-9]{10})$";
const fieldValueIsInvalid = "invalid";
const fieldValueIsValid = "valid";
var isVATNumberCheckInProgress = false;
export class CompanyForm extends Component {
    constructor(props) {
        super(props);
        this.deleteCompanyConfirmationModalYesHandler = this.deleteCompanyConfirmationModalYesHandler.bind(this);
        this.deleteCompanyConfirmationModalCancelHandler = this.deleteCompanyConfirmationModalCancelHandler.bind(this);
    }
    updateVATNumbers(vatNumbers) {
        log.debug('updateVATNumbers(): ', vatNumbers);

        // re-construct a full company object from the companyWithoutVatNumbers, and the supplied (updated) vatNumbers
        // and use that to submit (save) the whole company.
        this.props.submitHandler(Object.assign({}, this.props.companyWithoutVatNumbers, {vatNumbers: vatNumbers}));
        // Adding this because this.onSubmitForm does it, and it keeps the state consistent.
        this.props.doFormSubmitted(this.props.FORM_NAME_FOR_COMPANY);

    }
    askForDeleteCompanyConfirmation() {
        this.setState({
          showDeleteCompanyConfirmationModal: true,
        });
    }
    deleteCompanyConfirmationModalYesHandler() {
        this.setState({
            showDeleteCompanyConfirmationModal: false
        });
        this.onDeleteCompanyFactory();
    }
    deleteCompanyConfirmationModalCancelHandler() {
        this.setState({
            showDeleteCompanyConfirmationModal: false,
        });
    }
    onDeleteCompanyFactory() {
        log.debug('onDeleteCompanyFactory: ', this.props.formData.fieldValues.id,this.props.FORM_NAME_FOR_COMPANY);
        this.props.onDeleteCompany(this.props.FORM_NAME_FOR_COMPANY);
        this.props.deleteCompanyHandler(this.props.formData.fieldValues.id);
    }
    createVATNumber(vatnumber) {
        log.debug('vatnumber(): ', vatnumber);
        this.props.onCreateVATNumber(vatnumber);
    }
    deleteVATNumber(vatnumber) {
        log.debug('vatnumber(): ', vatnumber);
        this.props.onDeleteVATNumber(vatnumber.id);
    }

    onFormFocus(e) {
        log.debug('onFormFocus()');
        this.props.doClearAllErrors();
    }

    getCompanyFYStartMonthOptions() {
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let optionsList = [];
        monthNames.forEach((val, index) => {
            optionsList.push({
                label: LANGUAGES_CONTROLLER.format(this.props.languages, val),
                value: index+1+"",
                selected: fieldValues.bookYearStartMonth === (index+1+"")? true: false
            });
        });
        return optionsList;
    }

    getCompanyClosingDayOptions() {
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
        let optionsList = [];
        for(let i=1; i<31; i++) {
            optionsList.push({
                label: i,
                value: i+"",
                selected: fieldValues.closingDay === (i+"")? true: false
            });
        }
        return optionsList;
    }

    getCompanyCurrencyPriorityOptions() {
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
        let currencyPriorityList = ENUMS.getCurrencyPriorityList();
        let optionsList = [];
        currencyPriorityList.forEach((val) => {
            optionsList.push({
                label: val,
                value: val+"",
                selected: fieldValues.currencyPriority === (val+"")? true: false
            });
        });
        return optionsList;
    }

    getCompanyVatGroupTypeOptions(isEs) {
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
        let optionsList = [];
        const vatGroupName = isEs?'vatGroupTypeEs':'vatGroupTypeEsGc'
        CompanyVatGroupTypeEnum.enumValues.forEach((vatGroupType) => {
            optionsList.push({
                label: LANGUAGES_CONTROLLER.format(this.props.languages, vatGroupType.languageString),
                value: vatGroupType.value+"",
                selected: fieldValues[vatGroupName] === (vatGroupType.value+"")? true: false
            });
        });
        return JSON.parse(JSON.stringify(optionsList));
    }

    getCompanyActivityCodeOptions() {
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
        let optionsList = [{
            value: '',
            label: LANGUAGES_CONTROLLER.format(this.props.languages, 'company_ActivityCodeIT')
        }];
        this.props.activityCodesIT && this.props.activityCodesIT.forEach((codeString, index) => {
            const code = codeString.includes(" - ") ? codeString.split(" - ")[0].trim() : codeString.trim();
            optionsList.push({
                label: codeString,
                value: code,
                selected: fieldValues.itActivityCode === code? true: false
            });
        })
       return optionsList;
    }

    getCompanyTypeOptions() {
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
        let optionsList = [{
            value: '',
            label: LANGUAGES_CONTROLLER.format(this.props.languages, 'company_CompanyType')
        }];
        this.props.companyTypesIT && this.props.companyTypesIT.forEach((codeString, index) => {
            const code = codeString.includes(" - ") ? codeString.split(" - ")[0].trim() : codeString.trim();
            optionsList.push({
                label: codeString,
                value: code,
                selected: fieldValues.itCompanyType === code? true: false
            });
        })
       return optionsList;
    }

    render() {
        log.debug(' CompanyForm render(): ', this.props,this.props.company.vatNumbers,this.props.vatNumbers);
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
       if (!fieldValues) {
            return (<div data-test="component-page-load-waiting" ><LanguageStringResolver string='companiesPage_WaitingForFormToLoad'/></div>);
        }
        let currencyPriorityList = ENUMS.getCurrencyPriorityList();
        log.debug('currencyPriorityList',currencyPriorityList);

        //Validate Reg number on load
        var ossImportRegNrvalidClassName, ossUnionRegNrvalidClassName, ossNonUnionRegNrvalidClassName, ossImportIntermedValidClassName = fieldValueIsValid;
        if(this.state.ossImportRegNrValidValue === undefined && !_.isEmpty(fieldValues.ossImportRegNr))
            ossImportRegNrvalidClassName =  this.checkRegNumber(OSSImportRegEx,fieldValues.ossImportRegNr);
        else if(!_.isEmpty(this.state.ossImportRegNrValidValue))
            ossImportRegNrvalidClassName = this.state.ossImportRegNrValidValue;

        if(this.state.ossImportIntermediaryRegNrValidValue === undefined && !_.isEmpty(fieldValues.ossImportIntermediaryRegNr))
            ossImportIntermedValidClassName =  this.checkRegNumber(OSSImportIntermedRegEx ,fieldValues.ossImportIntermediaryRegNr);
        else if(!_.isEmpty(this.state.ossImportIntermediaryRegNrValidValue))
            ossImportIntermedValidClassName = this.state.ossImportIntermediaryRegNrValidValue;

        if(this.state.ossNonUnionRegNrValidValue === undefined && !_.isEmpty(fieldValues.ossNonUnionRegNr))
            ossNonUnionRegNrvalidClassName =  this.checkRegNumber(OSSNonUnionRegEx,fieldValues.ossNonUnionRegNr);
        else if(!_.isEmpty(this.state.ossNonUnionRegNrValidValue))
            ossNonUnionRegNrvalidClassName = this.state.ossNonUnionRegNrValidValue;


        if(fieldValues.id > 0 && this.state.ossUnionRegNrValidValue === undefined
            && !_.isEmpty(fieldValues.ossUnionRegNr)&& !_.isEmpty(fieldValues.optedForOssUnionSchemeInCountry) && isVATNumberCheckInProgress === false )
            ossUnionRegNrvalidClassName =  this.checkVATNumber(fieldValues.optedForOssUnionSchemeInCountry,fieldValues.ossUnionRegNr);
        else if(this.props.vatNumberCheck && this.props.vatNumberCheck.vatnumber === fieldValues.ossUnionRegNr)
            ossUnionRegNrvalidClassName = this.props.vatNumberCheck.technicalCheck && this.state.ossUnionRegNrValidValue === fieldValueIsValid ? fieldValueIsValid : fieldValueIsInvalid;
        else if(!_.isEmpty(this.state.ossUnionRegNrValidValue))
            ossUnionRegNrvalidClassName = this.state.ossUnionRegNrValidValue;

        return (
            <ReadOnlyWrapper>
                <div data-test="component-company-form">
                    <div className="clear"></div>
                    <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationWarning"/>
                    <h3 className="mt0">
                        {fieldValues.id > 0 ?
                            LANGUAGES_CONTROLLER.format(this.props.languages, 'company_EditCompanyDetails'):
                            LANGUAGES_CONTROLLER.format(this.props.languages, 'company_CreateNewCompany')
                        }
                    </h3>
                    <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationError"/>
                    <fieldset className="mb20" onFocus={this.onFormFocus.bind(this)}>
                        <HighlightOnInAppMessage
                            scopes={[FORM_NAME]}
                            messageIds={[ALL_MESSAGES.BLANK_COMPANY_CODE]}
                        >
                            <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Code')}:</label>
                            <input 
                                type="text"
                                value={fieldValues.code}
                                onChange={this.onFieldChangeHandlerFactory('code').bind(this)}
                                data-test="input-code"
                            />
                        </HighlightOnInAppMessage>
                        <HighlightOnInAppMessage
                            scopes={[FORM_NAME]}
                            messageIds={[ALL_MESSAGES.BLANK_COMPANY_NAME]}
                        >
                            <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Name')}:</label>
                            <input type="text" value={fieldValues.name} onChange={this.onFieldChangeHandlerFactory('name').bind(this)}
                                data-test="input-name"/>
                        </HighlightOnInAppMessage>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_FirstName')}:</label>
                                    <input type="text" value={fieldValues.privatePersonFirstName} onChange={this.onFieldChangeHandlerFactory('privatePersonFirstName').bind(this)}
                                        data-test="input-first-name"/>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_LastName')}:</label>
                                    <input type="text" value={fieldValues.privatePersonLastName} onChange={this.onFieldChangeHandlerFactory('privatePersonLastName').bind(this)}
                                        data-test="input-last-name"/>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_ContactPerson')}:</label>
                                    <SingleUserSelector userList={this.props.userList} fieldName={'responsible'} selectedUserId={fieldValues.responsible || ''} selectionHandler={this.onCountryChange.bind(this)}/>
                                    <HighlightOnInAppMessage
                                        scopes={[FORM_NAME]}
                                        messageIds={[ALL_MESSAGES.BLANK_COMPANY_STREET]}
                                    >
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Address_Street')}:</label>
                                    <input type="text" value={fieldValues.address} onChange={this.onFieldChangeHandlerFactory('address').bind(this)}
                                        data-test="input-street"/>
                                    </HighlightOnInAppMessage>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Address_HouseNumber')}:</label>
                                    <input type="text" value={fieldValues.houseNumber} onChange={this.onFieldChangeHandlerFactory('houseNumber').bind(this)} data-test="input-house-number"/>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Address_ApartmentNumber')}:</label>
                                    <input type="text" value={fieldValues.apartmentNumber} onChange={this.onFieldChangeHandlerFactory('apartmentNumber').bind(this)}/>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Address_POBox')}:</label>
                                    <input type="text" value={fieldValues.poBox} onChange={this.onFieldChangeHandlerFactory('poBox').bind(this)}/>
                                    <HighlightOnInAppMessage
                                        scopes={[FORM_NAME]}
                                        messageIds={[ALL_MESSAGES.BLANK_COMPANY_POSTCODE]}
                                    >
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Address_Postcode')}:</label>
                                    <input type="text" value={fieldValues.zip} onChange={this.onFieldChangeHandlerFactory('zip').bind(this)}
                                        data-test="input-postcode"/>
                                    </HighlightOnInAppMessage>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Address_Town')}:</label>
                                    <input type="text" value={fieldValues.city} onChange={this.onFieldChangeHandlerFactory('city').bind(this)}
                                        data-test="input-city"/>
                                    <HighlightOnInAppMessage
                                        scopes={[FORM_NAME]}
                                        messageIds={[ALL_MESSAGES.BLANK_COMPANY_COUNTRY]}
                                    >
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Address_Country')}:</label>
                                    <SingleCountrySelector disableFilterByLicence={true} countryList={this.props.countryList} fieldName={'country'} selectedCountryCode={fieldValues.country ? `${fieldValues.country}`.toUpperCase() : ''} selectionHandler={this.onCountryChange.bind(this)}/>
                                    </HighlightOnInAppMessage>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Telephone')}:</label>
                                    <input type="text" value={fieldValues.telephone} onChange={this.onFieldChangeHandlerFactory('telephone').bind(this)}
                                        data-test="input-telephone"/>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Fax')}:</label>
                                    <input type="text" value={fieldValues.fax} onChange={this.onFieldChangeHandlerFactory('fax').bind(this)}/>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Email')}:</label>
                                    <input type="text" value={fieldValues.email} onChange={this.onFieldChangeHandlerFactory('email').bind(this)} />
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Registration')}:</label>
                                    <input type="text" value={fieldValues.registerOfCommerce} onChange={this.onFieldChangeHandlerFactory('registerOfCommerce').bind(this)} />
                                    <s-row>
                                        <s-col span="6">
                                            <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_FinancialYearStartDay')}:</label>
                                            <input value={fieldValues.bookYearStartDay} onChange={this.onFieldChangeHandlerFactory('bookYearStartDay').bind(this)}/>
                                        </s-col>
                                        <s-col span="6">
                                            <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_FinancialYearStartMonth')}:</label>
                                            <SSelect defaultValue={fieldValues.bookYearStartMonth} 
                                                inputId="single-company-FinancialYearStartMonth-select"
                                                name="company_FinancialYearStartMonth"
                                                onS-select={this.onFieldChangeHandlerFactory('bookYearStartMonth').bind(this)}
                                                optionsList={this.getCompanyFYStartMonthOptions() || []}
                                                multiple={false}
                                                showSelectionCount={false}
                                            />
                                        </s-col>
                                    </s-row>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_ClosingDay')}:</label>
                                    <SSelect defaultValue={fieldValues.closingDay} 
                                        inputId="single-company-ClosingDay-select"
                                        name="company_ClosingDay"
                                        onS-select={this.onFieldChangeHandlerFactory('closingDay').bind(this)}
                                        optionsList={this.getCompanyClosingDayOptions() || []}
                                        multiple={false}
                                        showSelectionCount={false}
                                    />
                                    <s-row className="mt10">
                                        <s-col span="4">
                                            <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_CurrencyPriority')}:</label>
                                            <SSelect defaultValue={fieldValues.closingDay} 
                                                inputId="single-company-CurrencyPriorityy-select"
                                                name="company-CurrencyPriority"
                                                onS-select={this.onFieldChangeHandlerFactory('currencyPriority').bind(this)}
                                                optionsList={this.getCompanyCurrencyPriorityOptions() || []}
                                                multiple={false}
                                                showSelectionCount={false}
                                            />
                                        </s-col>
                                        <s-col span="8">
                                            <input className="mt40" type="checkbox" checked={fieldValues.useFirstCurrencyIfValid === 1 } onChange={this.onFieldChangeHandlerFactory('useFirstCurrencyIfValid').bind(this)}/>
                                            <label className="checkbox mt40">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_UseFirstCurrency')}</label>
                                            <span className="clear"></span>
                                        </s-col>
                                    </s-row>
                                    <s-row className="mt10 mb15">
                                        <s-col span="4"></s-col>
                                        <s-col span="8">
                                            <input className="mt10" type="checkbox" checked={fieldValues.active === 1} onChange={this.onFieldChangeHandlerFactory('active').bind(this)}/>
                                            <label className="checkbox mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Active')}</label>
                                            <span className="clear"></span>
                                        </s-col>
                                    </s-row>
                                    <hr className="mt30 mb20" />
                                    <fieldset>
                                        <h4>{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_VatGroups')}</h4>
                                        <s-row className="mt10 mb15">
                                                <s-col span="4">
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_VatGroupTypeEs')}</label>
                                                    <SSelect defaultValue={fieldValues.vatGroupTypeEs} 
                                                        inputId="single-company-VatGroupTypeEs-select"
                                                        name="company-VatGroupTypeEs"
                                                        onS-select={this.onFieldChangeHandlerFactory('vatGroupTypeEs').bind(this)}
                                                        optionsList={this.getCompanyVatGroupTypeOptions(true) || []}
                                                        multiple={false}
                                                        showSelectionCount={false}
                                                    />
                                                </s-col>
                                                <s-col span="4">
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_VatGroupTypeEsGc')}</label>
                                                    <SSelect defaultValue={fieldValues.vatGroupTypeEsGc} 
                                                        inputId="single-company-VatGroupTypeEsGc-select"
                                                        name="company-VatGroupTypeEsGc"
                                                        onS-select={this.onFieldChangeHandlerFactory('vatGroupTypeEsGc').bind(this)}
                                                        optionsList={this.getCompanyVatGroupTypeOptions(false) || []}
                                                        multiple={false}
                                                        showSelectionCount={false}
                                                    />
                                                </s-col>
                                        </s-row>
                                    </fieldset>
                                    <hr className="mt20 mb10" />
                                    <fieldset>
                                        <h4>{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_OSS')}</h4>
                                        <s-row className="mt10">
                                            <s-col span="4">
                                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_OptedOSSUnion')}:</label>
                                                <SingleCountrySelector countryList={this.props.euCountryList}  fieldName={'optedForOssUnionSchemeInCountry'} selectedCountryCode={fieldValues ? fieldValues[`optedForOssUnionSchemeInCountry`] : ''} selectionHandler={this.onCountryChange.bind(this)} hideCountryCode={true}/>
                                            </s-col>
                                            <s-col span="4">
                                                <HighlightOnInAppMessage
                                                    scopes={[FORM_NAME]}
                                                    messageIds={[ALL_MESSAGES.BLANK_OSSUNION_REGNR, ALL_MESSAGES.BLANK_OSSUNION_COUNTRY]}
                                                >
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_OSSUnionRegNr')}:</label>
                                                    <input type="text" value={fieldValues.ossUnionRegNr} onBlur={this.onUnionRegNumberEntered().bind(this)} className={ossUnionRegNrvalidClassName} onChange={this.onFieldChangeHandlerFactory('ossUnionRegNr').bind(this)}/>
                                                </HighlightOnInAppMessage>
                                            </s-col>
                                        </s-row>
                                        <s-row className="mt10">
                                            <s-col span="4">
                                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_OptedOSSNonUnion')}:</label>
                                                {/*TODO replace MossCountryList with this.props.euCountryList*/}
                                                <SingleCountrySelector countryList={this.props.euCountryList}  fieldName={'optedForOssNonUnionSchemeInCountry'} selectedCountryCode={fieldValues ? fieldValues[`optedForOssNonUnionSchemeInCountry`] : ''} selectionHandler={this.onCountryChange.bind(this)} hideCountryCode={true}/>
                                            </s-col>
                                            <s-col span="4">
                                                <HighlightOnInAppMessage
                                                    scopes={[FORM_NAME]}
                                                    messageIds={[ALL_MESSAGES.BLANK_OSSNONUNION_REGNR,ALL_MESSAGES.BLANK_OSSNONUNION_COUNTRY]}
                                                >
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_OSSNonUnionRegNr')}:</label>
                                                    <input type="text" value={fieldValues.ossNonUnionRegNr} onBlur={this.onNonUnionRegNumberEntered().bind(this)} className={ossNonUnionRegNrvalidClassName} onChange={this.onFieldChangeHandlerFactory('ossNonUnionRegNr').bind(this)}/>
                                                </HighlightOnInAppMessage>
                                            </s-col>
                                        </s-row>
                                        <s-row className="mt10">
                                            <s-col span="4">
                                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_OptediOOS')}:</label>
                                                <SingleCountrySelector countryList={this.props.euCountryList}  fieldName={'optedForOssImportSchemeInCountry'} selectedCountryCode={fieldValues ? fieldValues[`optedForOssImportSchemeInCountry`] : ''} selectionHandler={this.onCountryChange.bind(this)} hideCountryCode={true}/>
                                            </s-col>
                                            <s-col span="4">
                                                <HighlightOnInAppMessage
                                                    scopes={[FORM_NAME]}
                                                    messageIds={[ALL_MESSAGES.BLANK_iOSS_REGNR, ALL_MESSAGES.BLANK_iOSS_COUNTRY]}
                                                >
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_iOSSUnionRegNr')}:</label>
                                                    <input type="text" value={fieldValues.ossImportRegNr} onBlur={this.onImportRegNumberEntered().bind(this)} className={ossImportRegNrvalidClassName} onChange={this.onFieldChangeHandlerFactory('ossImportRegNr').bind(this)}/>
                                                </HighlightOnInAppMessage>
                                            </s-col>
                                        </s-row>
                                        <s-row className="mt10">
                                            <s-col span="4">
                                                <div></div>
                                            </s-col>
                                            <s-col span="4">
                                                <HighlightOnInAppMessage
                                                    scopes={[FORM_NAME]}
                                                    messageIds={[ALL_MESSAGES.BLANK_iOSS_INTR_REGNR_COUNTRY]}
                                                >
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_OssImportIntermediaryRegNr')}:</label>
                                                    <input type="text" value={fieldValues.ossImportIntermediaryRegNr} onBlur={this.onImportIntermediaryRegNumberEntered().bind(this)} className={ossImportIntermedValidClassName} onChange={this.onFieldChangeHandlerFactory('ossImportIntermediaryRegNr').bind(this)}/>
                                                </HighlightOnInAppMessage>
                                            </s-col>
                                        </s-row>
                                    </fieldset>
                                    <hr className="mt30 mb20" />
                                    <fieldset>
                                        <h4>{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Spain')}</h4>
                                        <s-row className="mt10">
                                            <s-col span="8">
                                                <input className="mt10" type="checkbox" checked={fieldValues.aboveThresholdES === 1 } onChange={this.onFieldChangeHandlerFactory('aboveThresholdES').bind(this)}/>
                                                <label className="checkbox mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_AboveThresholdES')}</label>
                                            </s-col>
                                        </s-row>
                                    </fieldset>
                                    { !this.props.newCompany && this.props.featureFlags?.[FeatureFlagEnum.ENABLE_ITALY_LOOKUPS] ?
                                        <>
                                            <hr className="mt30 mb20" />
                                            <fieldset>
                                                <h4>{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Italy')}</h4>
                                                <s-row className="mt10">
                                                    <s-col span="4"> 
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_ActivityCode')}:</label>
                                                    <SSelect defaultValue={fieldValues.itActivityCode || ''} 
                                                        inputId="single-company_ActivityCode-select"
                                                        name="company_ActivityCode"
                                                        onS-select={this.onFieldChangeHandlerFactory('itActivityCode').bind(this)}
                                                        optionsList={this.getCompanyActivityCodeOptions() || []}
                                                        multiple={false}
                                                        showSelectionCount={false}
                                                        data-testid="company-form-activity-code"
                                                    />
                                                    </s-col>
                                                    <s-col span="4"> 
                                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_CompanyType')}:</label>
                                                    <SSelect defaultValue={fieldValues.itCompanyType || ''} 
                                                        inputId="single-company_CompanyType-select"
                                                        name="company_CompanyType"
                                                        onS-select={this.onFieldChangeHandlerFactory('itCompanyType').bind(this)}
                                                        optionsList={this.getCompanyTypeOptions() || []}
                                                        multiple={false}
                                                        showSelectionCount={false}
                                                        data-testid="company-form-company-type"
                                                    />
                                                    </s-col>
                                                </s-row>
                                            </fieldset>
                                            <hr className="mt30 mb20" />
                                        </>
                                        : <div></div>
                                    }
                                </fieldset>
                                <div className="bottom-nav-panel-sticky">
                                    <div className="bottom-nav-panel">
                                        <a className="button primary mt0" onClick={this.onSubmitForm.bind(this)} data-test="company-submit">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Submit')}</a>
                                        <a className="button secondary mt0" onClick={this.onResetForm.bind(this)}data-test="company-reset">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Reset')}</a>
                                    </div>
                                </div>
                            <div>
                        </div>
                    <div className="mt10 delete-btn-container">
                        {
                        this.props.vatNumbers  && fieldValues.id > 0 ? (
                        <button data-testid="button-delete-company" className="secondary mt0 mr0 mb15" onClick={this.askForDeleteCompanyConfirmation.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_Delete')}</button>
                        ) : (<div></div>)}
                    </div>
                    <div>
                        <ConfirmationModal 
                        isModalPopupOpen={this.state.showDeleteCompanyConfirmationModal}
                        modelTitle = "company_Delete"
                        modelMessage = "companiesPage_deleteCompanyConfirmation"
                        onYesClickHandler = {this.deleteCompanyConfirmationModalYesHandler}
                        onCancelClickHandler = {this.deleteCompanyConfirmationModalCancelHandler}
                        />
                    </div>
                </div>
            </ReadOnlyWrapper>
        );


    }

    onImportRegNumberEntered()
    {
        return () => {
                this.setState({
                    ossImportRegNrValidValue: !_.isEmpty(this.props.formData.fieldValues.ossImportRegNr) ?
                        this.checkRegNumber(OSSImportRegEx,this.props.formData.fieldValues.ossImportRegNr):
                        fieldValueIsValid
                });
        }
    }

    checkRegNumber(regEx,regNumber)
    {
        const res = new RegExp(regEx).test(regNumber);
        return !res ? fieldValueIsInvalid : fieldValueIsValid;
    }

    onNonUnionRegNumberEntered()
    {
        return () => {
                this.setState({
                    ossNonUnionRegNrValidValue: !_.isEmpty(this.props.formData.fieldValues.ossNonUnionRegNr) ?
                        this.checkRegNumber(OSSNonUnionRegEx,this.props.formData.fieldValues.ossNonUnionRegNr) :
                        fieldValueIsValid
                });
        }
    }

    onImportIntermediaryRegNumberEntered()
    {
        return () => {
                this.setState({
                    ossImportIntermediaryRegNrValidValue: !_.isEmpty(this.props.formData.fieldValues.ossImportIntermediaryRegNr) ?
                        this.checkRegNumber(OSSImportIntermedRegEx,this.props.formData.fieldValues.ossImportIntermediaryRegNr) :
                        fieldValueIsValid
                });
        }
    }

    checkVATNumber(country,regNumber)
    {
        log.debug('checkVATNumber(): ', regNumber);
        const res = _.find(this.props.vatValidationRules, function (elem) {
                return elem.key === country;}).value.test(regNumber);
        if(!res)
            return fieldValueIsInvalid;
        else
        {
            var callback = (response) => {
                if(response.vatNumber == this.props.formData.fieldValues.ossUnionRegNr) {
                    isVATNumberCheckInProgress = false;
                    this.setState({
                        ossUnionRegNrValidValue: response.technicalCheck === true ? fieldValueIsValid : fieldValueIsInvalid
                    });
                }
            };
            //If registration number pass reg ex then perform deep check (SaaS API)
            this.props.doValidateVATNumber(regNumber.trim(),callback);
            isVATNumberCheckInProgress = true;
            return fieldValueIsValid;
        }
    }

    onUnionRegNumberEntered()
    {
        return () => {

                this.setState({
                    ossUnionRegNrValidValue: !_.isEmpty(this.props.formData.fieldValues.ossUnionRegNr) &&
                    !_.isEmpty(this.props.formData.fieldValues.optedForOssUnionSchemeInCountry) ?
                        this.checkVATNumber(this.props.formData.fieldValues.optedForOssUnionSchemeInCountry,this.props.formData.fieldValues.ossUnionRegNr) :
                        fieldValueIsValid
                });
        }
    }
    componentWillUnmount() {
        log.debug('componentWillUnmount(): ', this.props);
        //removed doDestroyForm, as it's causing delete form for wrong company 
    }
    clearErrorMessages()
    {
        log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_COUNTRY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_CODE);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_POSTCODE);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_NAME);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_STREET);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSUNION_REGNR);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSNONUNION_REGNR);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_iOSS_REGNR);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSUNION_COUNTRY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSNONUNION_COUNTRY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_iOSS_COUNTRY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_iOSS_INTR_REGNR_COUNTRY);
    }
    UNSAFE_componentWillMount() {
        log.debug('componentWillMount(): ', this.props);
        // use the company details we've prepared without vatNumbers in the mapStateToProps
        this.clearErrorMessages();
        this.props.doInitialiseForm(this.props.FORM_NAME_FOR_COMPANY, this.props.companyWithoutVatNumbers);
        this.setState({
            ossImportRegNrValidValue: undefined,
            ossNonUnionRegNrValidValue: undefined,
            ossImportIntermediaryRegNrValidValue: undefined,
            ossUnionRegNrValidValue : undefined
        });
        const { featureFlags } = getClientConfig();
        const enableItalyLookups = featureFlags?.EnableItalyLookups;
        if (enableItalyLookups && !this.props.newCompany) {
            this.props.loadItalyLookups();
        }
    }
    onCountryChange(keyValue)
    {
        log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_COUNTRY);
        log.debug('onCountryChange(): ', keyValue);
        let fieldName = '', value = ''
        for(let i in keyValue) {
            fieldName = i;
            value = keyValue[i];            
            this.props.onFieldChange(this.props.FORM_NAME_FOR_COMPANY, fieldName, value);
        }
    }

    onFieldChangeHandlerFactory(fieldName, maxLength = null) {

        return (evt) => {
            if(fieldName === 'code') {log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_CODE);}
            if(fieldName === 'name') {log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_NAME);}
            if(fieldName === 'address') {log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_STREET);}
            if(fieldName === 'zip') {log.clearDictionaryError(ALL_MESSAGES.BLANK_COMPANY_POSTCODE);}
            if(fieldName === 'ossUnionRegNr') {log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSUNION_REGNR);
                                                log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSUNION_COUNTRY)}
            if(fieldName === 'ossNonUnionRegNr') {log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSNONUNION_REGNR);
                                                log.clearDictionaryError(ALL_MESSAGES.BLANK_OSSNONUNION_COUNTRY);}
            if(fieldName === 'ossImportRegNr') {log.clearDictionaryError(ALL_MESSAGES.BLANK_iOSS_REGNR);
                                                log.clearDictionaryError(ALL_MESSAGES.BLANK_iOSS_INTR_REGNR_COUNTRY);}

            let value;
            switch (fieldName) {
                case 'operatesInVatGroup':
                case 'useFirstCurrencyIfValid':
                case 'active':
                case 'aboveThresholdES':
                    value = evt.target.checked ? 1 : 0;
                    //log.debug('onFieldChangeHandlerFactory(): ', fieldName,evt.target.value,evt.target);
                break;
                case 'optedForMossInCountry':
                case 'reporterType':
                case 'itActivityCode':
                    value = evt.detail.item.value;
                    break;
                case 'itCompanyType':
                    value = evt.detail.item.value;
                    break;
                case 'bookYearStartMonth':
                    value = evt.detail.item.value;
                    break;
                case 'closingDay':
                    value = evt.detail.item.value;
                    break;
                case 'currencyPriority':
                    value = evt.detail.item.value;
                    break;
                case 'vatGroupTypeEs':
                    value = evt.detail.item.value;
                    break;
                case 'vatGroupTypeEsGc':
                    value = evt.detail.item.value;
                    break;
                default:
                    value = evt.target.value;
            }
            this.props.onFieldChange(this.props.FORM_NAME_FOR_COMPANY, fieldName, value)
        }
    }

    onSubmitForm() {
        log.debug('onSubmitForm(): ', this.props.formData);
        if (!this.props.formData || typeof this.props.formData.fieldValues !== 'object') {
            return; // TODO: Maybe a dialog to confirm blank entry?
        }
        let fieldsOk = true;
        this.clearErrorMessages();

        const companyCode = this.props.formData.fieldValues.code.trim();
        const formNameForCompany = FORM_NAME+'_FOR_'+companyCode;
        const companyName = this.props.formData.fieldValues.name.trim();
        const companyStreet = this.props.formData.fieldValues.address.trim();
        const companyCountry = this.props.formData.fieldValues.country.trim();
        const companyPostCode = this.props.formData.fieldValues.zip.trim();
        const optedForOssUnionSchemeInCountry = this.props.formData.fieldValues.optedForOssUnionSchemeInCountry;
        const OssUnionRegNr = this.props.formData.fieldValues.ossUnionRegNr && this.props.formData.fieldValues.ossUnionRegNr.trim();
        const optedForOssNonUnionSchemeInCountry = this.props.formData.fieldValues.optedForOssNonUnionSchemeInCountry;
        const OssNonUnionRegNr = this.props.formData.fieldValues.ossNonUnionRegNr && this.props.formData.fieldValues.ossNonUnionRegNr.trim();
        const optedForOssImportSchemeInCountry = this.props.formData.fieldValues.optedForOssImportSchemeInCountry;
        const OssImportRegNr = this.props.formData.fieldValues.ossImportRegNr && this.props.formData.fieldValues.ossImportRegNr.trim();
        const ossImportIntermediaryRegNr= this.props.formData.fieldValues.ossImportIntermediaryRegNr && this.props.formData.fieldValues.ossImportIntermediaryRegNr.trim();
        if ( companyCode === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_COMPANY_CODE);
            fieldsOk = false;
        }

        if ( companyName === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_COMPANY_NAME);
            fieldsOk = false;
        }

        if ( companyStreet === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_COMPANY_STREET);
            fieldsOk = false;
        }
        if ( companyPostCode === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_COMPANY_POSTCODE);
            fieldsOk = false;
        }
        if ( companyCountry === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_COMPANY_COUNTRY);
            fieldsOk = false;
        }
        if(!_.isEmpty(optedForOssUnionSchemeInCountry) && _.isEmpty(OssUnionRegNr))
        {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_OSSUNION_REGNR);
            fieldsOk = false;
        }
        if(!_.isEmpty(optedForOssNonUnionSchemeInCountry) && _.isEmpty(OssNonUnionRegNr))
        {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_OSSNONUNION_REGNR);
            fieldsOk = false;
        }
        if(!_.isEmpty(optedForOssImportSchemeInCountry) && _.isEmpty(OssImportRegNr))
        {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_iOSS_REGNR);
            fieldsOk = false;
        }
        if(_.isEmpty(optedForOssUnionSchemeInCountry) && !_.isEmpty(OssUnionRegNr))
        {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_OSSUNION_COUNTRY);
            fieldsOk = false;
        }
        if(_.isEmpty(optedForOssNonUnionSchemeInCountry) && !_.isEmpty(OssNonUnionRegNr))
        {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_OSSNONUNION_COUNTRY);
            fieldsOk = false;
        }
        if(_.isEmpty(optedForOssImportSchemeInCountry) && !_.isEmpty(OssImportRegNr))
        {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_iOSS_COUNTRY);
            fieldsOk = false;
        }
        if(_.isEmpty(optedForOssImportSchemeInCountry) && !_.isEmpty(ossImportIntermediaryRegNr))
        {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_iOSS_INTR_REGNR_COUNTRY);
            fieldsOk = false;
        }
        if (!fieldsOk) {
            return;
        }
        // Since we have separated the vat numbers from the rest of the company details
        // we have to remember to re-construct the full company object with vat numbers when we call the submit handler
        this.props.submitHandler(Object.assign({}, this.props.formData.fieldValues, {vatNumbers: this.props.vatNumbers}));
        // Let the forms controller know that the form has been submitted.

        {this.props.newCompany === true ? (
            this.props.doFormSubmitted(formNameForCompany)
            ) : (
            this.props.doFormSubmitted(this.props.FORM_NAME_FOR_COMPANY)
        )}

        //Reset form for create company
        if(this.props.formData.fieldValues.id === 0) {
            this.props.doResetForm(this.props.FORM_NAME_FOR_COMPANY);
        }

    }
    onResetForm() {
        log.debug('onResetForm(): ');
        this.clearErrorMessages();
        this.setState({
            ossImportRegNrValidValue: undefined,
            ossNonUnionRegNrValidValue: undefined,
            ossImportIntermediaryRegNrValidValue: undefined,
            ossUnionRegNrValidValue : undefined
        });
        this.props.doResetForm(this.props.FORM_NAME_FOR_COMPANY);
    }
    onClearForm() {
        log.debug('onClearForm(): ');
        this.props.doClearForm(this.props.FORM_NAME_FOR_COMPANY);

    }
}

function mapStateToProps(state, props) {
    log.debug('mapStateToProps(): ', state);
    log.debug('mapStateToProps(): props', props);

    // Because of the way the UX is designed, with multiple companies allowed to be edited, we will have multiple forms too
    // However we need to construct a unique form name per company, for the FORMS_CONTROLLER not to mix them up.
    // Using the company's code as a suffix should work for existing companies, but we will need to think about new companies.
    // TODO: how do we manage new companies? Specifically the creation of multiple new companies.
    const formNameForCompany = FORM_NAME+'_FOR_'+props.company.code;
    return {
        // Almost all components will need to use language strings, so add them to the props from the global state
        languages: state.languages,
        formData: (state.managedUxForms && state.managedUxForms.forms[formNameForCompany]),
        FORM_NAME_FOR_COMPANY: formNameForCompany,
        // separate the company details from the vat numbers, and ensure they are available in the props
        // This will allow us to use this form ONLY for company details,
        // and the vat number forms for the company's VAT Numbers.
        companyWithoutVatNumbers: Object.assign({}, props.company, {vatNumber: undefined}),
        vatNumbers: props.company.vatNumbers,
        userList: state.companies && state.companies.contactPersonUsers,
        euCountryList : (state.content && state.content.contentData && state.content.contentData.euCountryList),
        vatValidationRules: state.content && state.content.vatNumberRules,
        vatNumberCheck: state.companies.vatNumberCheck,
        countryList : (state.content && state.content.contentData && state.content.contentData.countryList),
        showDeleteCompanyConfirmationModal: false,
        activityCodesIT: state.companies && state.companies.activityCodesIT,
        companyTypesIT: state.companies && state.companies.companyTypesIT,
        featureFlags: state.featureFlag && state.featureFlag.data
        // TODO: Add additional data we want to extract from the global state and inject into the props here
    };
}


function mapDispatchersToProps(dispatch) {
    return {
        // Standard form actions
        doInitialiseForm: (formNameForCompany,initialValues) => {
            log.debug('doInitialiseForm: ',   initialValues);
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(formNameForCompany, initialValues));
        },
        
        doResetForm: (formNameForCompany) => {
            dispatch(COMPANIES_CONTROLLER.doClearAllErrors());
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(formNameForCompany));
        },
        
        doClearForm: (formNameForCompany) => {
            dispatch(COMPANIES_CONTROLLER.doClearAllErrors());
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(formNameForCompany));
        },

        onFieldChange: (formNameForCompany, fieldName, value) => {            
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(formNameForCompany, fieldName, value));
        },
        
        doFormSubmitted: (formNameForCompany) => {
            dispatch(COMPANIES_CONTROLLER.doClearAllErrors());
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(formNameForCompany));
        },

        doDestroyForm: (formNameForCompany) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(formNameForCompany));
        },

        onCreateVATNumber: (vatnumber) => {
            log.debug('onUpdatevatnumber: ',   vatnumber);
            //TO DO - Add VAT number to existing company.vatNumbers[]
            //dispatch(COMPANIES_CONTROLLER.doCreate(vatnumber));
        },

        onDeleteCompany: (formNameForCompany)=> {
            log.debug('onDeleteCompany: ',formNameForCompany);
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(formNameForCompany));
        },

        onUpdateVATNumber: (id, vatnumber) => {
            log.debug('onUpdateUser: ', id, vatnumber);
            //TO DO - Update VAT number and set updated to existing company.vatNumbers[]
           // dispatch(COMPANIES_CONTROLLER.doUpdate(id, company));
        },

        onDeleteVATNumber: (id) => {
            log.debug('onDeleteUser: ', id);
            //TO DO - delete VAT number from existing company.vatNumbers[]
          //  dispatch(COMPANIES_CONTROLLER.doDelete(id));
        },
        doClearAllErrors: () => {
            log.debug("doClearAllErrors(): ");
            dispatch(COMPANIES_CONTROLLER.doClearAllErrors());
        },
        doValidateVATNumber: (vatnumber,callback) =>
        {
            dispatch(COMPANIES_CONTROLLER.doValidateVATNumber(vatnumber,callback));
        },
        loadItalyLookups: () => {
            dispatch(COMPANIES_CONTROLLER.doLoadItalyLookups());
        }
        //TODO: Add dispatchers (actions we expect controllers to perform) here.
    }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(CompanyForm);
